import { Component, Input, OnInit, OnChanges, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ReusableMerchantTemplate } from '../../pages/merchants/merchant-template/reusable-merchant-template';

@Component({
    selector: 'statement-template',
    templateUrl: './statement-template.component.html',
    styleUrls: ['./statement-template.component.scss'],
    standalone: false
})
export class StatementTemplateComponent implements OnInit, OnChanges {
    @Input() formGroup!: UntypedFormGroup;
    @Input() formArrayName: string = 'merchantTemplates';
    @Input() title = '';
    @Input() subtitle = '';

    get formArray(): UntypedFormArray {
        return this.formGroup.get(this.formArrayName) as UntypedFormArray;
    }

    @ViewChildren(ReusableMerchantTemplate) templateComponents: QueryList<ReusableMerchantTemplate>;

    wrapperGroup: UntypedFormGroup;

    constructor(private fb: UntypedFormBuilder) { }

    ngOnInit() {
        if (this.formArray) {
            this.wrapperGroup = this.fb.group({
                merchantTemplates: this.formArray
            });
        }
    }

    ngOnChanges() {
        if (this.formArray && !this.wrapperGroup) {
            this.wrapperGroup = this.fb.group({
                merchantTemplates: this.formArray
            });
        }
    }

    addAnotherMerchantTemplate() {
        this.formArray.push(this.fb.control({}));
    }

    removeMerchantTemplate(index: number) {
        if (this.formArray.length > 1) {
            this.formArray.removeAt(index);
        }
    }

    allTemplatesValid(): boolean {
        return this.formArray.controls.length > 0 &&
            this.formArray.controls.every(control => {
                const val = control.value;
                if (!val) return false;
                return control.valid &&
                    val.feeLabel &&
                    val.feeDescription &&
                    val.volume &&
                    val.numberOfTransactions;
            });
    }
}